<template>
  <Wrapper hasChildren @openEditor="openEditor" @openChildEditor="openChildEditor">
    <div class="photo-wall-container">
      <div class="title" :class="!title && 'no-wrapper'">
        <div class="title-text module-text-title" ref="titleEl">{{ title }}</div>
        <div class="under-line" :style="titleUnderLineStyle">
          <el-divider v-if="hasTitleUnderLine"></el-divider>
        </div>
      </div>
      <div class="sub-title" :class="!subTitle && 'no-wrapper'">
        <div class="sub-title-text module-text-content" ref="subTitleEl">{{ subTitle }}</div>
        <div class="under-line" :style="subTitleUnderLineStyle">
          <el-divider v-if="hasSubTitleUnderLine"></el-divider>
        </div>
      </div>
      <div class="photo-list" :class="renderMode">
        <slot></slot>
      </div>
    </div>
  </Wrapper>
</template>

<script>
import _ from 'lodash'
import Wrapper from '../../../components/render/wrapper'
import RenderMode from '../RenderMode'
import { childName } from '../index'

export default {
  components: {
    Wrapper
  },
  props: {
    renderMode: {
      type: String,
      required: true,
      validator: (value) => {
        return _.find(RenderMode, (itemValue) => itemValue === value)
      }
    },
    title: {
      type: String,
      default: ''
    },
    subTitle: {
      type: String,
      default: ''
    },
    underLine: {
      type: Object,
      required: false
    },
    styleConfig: {
      type: Object,
      required: false
    }
  },
  data () {
    return {

    }
  },
  computed: {
    hasTitleUnderLine () {
      return this.underLine && this.underLine.title && this.underLine.title.isShow && this.title && this.subTitle
    },
    hasSubTitleUnderLine () {
      return this.underLine && this.underLine.subTitle && this.underLine.subTitle.isShow
    },
    titleUnderLineStyle () {
      return this.formatUnderLineStyle('title', this.underLine.title)
    },
    subTitleUnderLineStyle () {
      return this.formatUnderLineStyle('subTitle', this.underLine.subTitle)
    }
  },
  created () {

  },
  methods: {
    formatUnderLineStyle (type, config, isSelfTigger) {
      let width = config.width
      let el = null
      if (this.$refs) {
        if (type === 'title') {
          el = this.$refs.titleEl
        } else if (type === 'subTitle') {
          el = this.$refs.subTitleEl
        } else if (type === 'content') {
          el = this.$refs.contentEl
        }
      }
      if (el) {
        if (!width || width === 'full') {
          width = '100%'
        } else if (!isNaN(width)) {
          width = width + 'px'
        } else if (width === 'compute') {
          width = (el.clientWidth + 60) + 'px'
        }
        const underLineEl = el.nextElementSibling.firstElementChild
        if (underLineEl) {
          const style = underLineEl.style
          style.width = width
          style.backgroundColor = config.color || '#DCDFE6'
        }
      } else if (!isSelfTigger) {
        this.$nextTick(() => this.formatUnderLineStyle(type, config, true))
      }
      return { }
    },
    openEditor () {
      this.$emit('openEditor')
    },
    openChildEditor () {
      this.$emit('openChildEditor', {
        editorName: childName,
        fromChild: false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.site-common {
  .photo-wall-container {
    text-align: center;

    .under-line {
      width: 100%;

      .el-divider {
        margin: 0 auto;
      }
    }

    .title {
      margin-bottom: 25px;
    }

    .title-text, .sub-title-text {
      display: inline-block;
    }

    .photo-list {
      margin-top: 20px;
    }

    ::v-deep .photo-list {
      .child-wrapper {
        display: inline-block;
      }

      &.normal {
        .photo-item {
          .photo-container {
            .photo {
              // width: 200px;
              // height: 200px;
            }
          }
        }
      }

      &.logo {
        .photo-item {
          .photo-container {
            .photo {
              width: 200px;
              height: 200px;
            }
          }
        }
      }

      &.brand {
        .photo-item {
          .photo-container {
            background: #f2f2f2;

            .photo {
              width: 120px;
              height: 40px;
              margin: 25px;
            }
          }
        }
      }
    }
  }
}

.site-mobile {
  .photo-wall-container {
    padding: 0 10px;

    .title {
      .under-line {
        margin-top: 10px;
      }
    }

    ::v-deep .photo-list {
      &.normal {
        .photo-item {
          .photo-container {
            .photo {
              width: 100%;
            }
          }
        }
      }
    }
  }
}

.site-pc {
  .photo-wall-container {
    width: 1080px;
    margin: 0 auto;

    .title {
      .under-line {
        margin-top: 20px;
      }
    }

    ::v-deep .photo-list {
      &.normal {
        margin-top: 0;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .child-wrapper {
          margin-top: 40px;

          .photo-item {
            padding: 0;
            height: 100%;

            .photo-container {
              height: 100%;

              .photo {
                width: 240px;
                height: 100%;
              }
            }
          }
        }
      }

      &.logo {

      }

      &.brand {

      }
    }
  }
}
</style>
